import React, { useEffect, useMemo, useState } from 'react';
import Chart from './chart';
import Api from '../api';
import dayjs from 'dayjs';


enum TimeRange {
    HalfDay = '12h',
    Day = '1d',
    Week = '7d'
}

function timeRangeToHours(timeRange: TimeRange): number {
    const timeRangeHours = {
        [TimeRange.HalfDay]: 12,
        [TimeRange.Day]: 24,
        [TimeRange.Week]: 24 * 7
    };
    return timeRangeHours[timeRange];
}

function timeRangeToDomain(timeRange: TimeRange): [Date, Date] {
    return [dayjs().subtract(timeRangeToHours(timeRange), 'hour').toDate(), new Date()];
}


const Charts: React.FC = () => {
    const api = useMemo(() => new Api(), []);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<DataPoint[]>([]);
    const [timeRange, setTimeRange] = useState<TimeRange>(TimeRange.Day);
    const [timeRangeDomain, setTimeRangeDomain] = useState<[Date, Date]>(timeRangeToDomain(timeRange));

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            try {
                const createdAtSince = dayjs().subtract(timeRangeToHours(timeRange), 'hour').toISOString();
                setData(await api.fetchMeasurements(createdAtSince));
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        setTimeRangeDomain(timeRangeToDomain(timeRange))
    }, [timeRange, api]);

    return (
        <div style={{ width: '100%', boxSizing: 'border-box' }}>
            <div className="charts-container" style={{ marginBottom: '20px', gap: '10px' }}>
                <label>Time Range:</label>
                <select
                    value={timeRange}
                    onChange={(e) => setTimeRange(e.target.value as TimeRange)}
                    style={{
                        padding: '8px',
                        borderRadius: '4px',
                        fontSize: '16px'
                    }}
                >
                    <option value={TimeRange.HalfDay}>Last 12 Hours</option>
                    <option value={TimeRange.Day}>Last 24 Hours</option>
                    <option value={TimeRange.Week}>Last 7 Days</option>
                </select>
            </div>

            {!loading ?
                <div className="charts-container">
                    <Chart
                        data={data}
                        title="Temperature"
                        dataKey="t"
                        stroke="#8884d8"
                        domain={timeRangeDomain}
                    />
                    <Chart
                        data={data}
                        title="Humidity"
                        dataKey="h"
                        stroke="#82ca9d"
                        domain={timeRangeDomain}
                    />
                    <Chart
                        data={data}
                        title="CO2"
                        dataKey="co2"
                        stroke="#ffc658"
                        domain={timeRangeDomain}
                    />
                </div>
                : <div className="charts-container">Loading...</div>}
        </div>
    );
}


export default Charts;